'use strict';

(function () {
  'use strict';

  angular.module('msActivities').controller('ActivityProgramCtrl', ActivityProgramCtrl);

  ActivityProgramCtrl.$inject = ['program', 'NotifyingSvc', 'activityRouter', 'errorRouter', 'focus'];

  /* @ngInject */
  function ActivityProgramCtrl(program, NotifyingSvc, activityRouter, errorRouter, focus) {
    var vm = this;
    vm.title = 'ActivityProgramCtrl';
    vm.createTrain = activityRouter.createTrain;

    activate();

    ////////////////

    function activate() {
      if (program == null) {
        errorRouter.navigateError({
          message: 'Unable to load the program',
          contact: false
        });
      }
      vm.program = program;
      // find the next incomplete series, or just the first one again if they've completed all
      vm.startingSeries = vm.program.series.filter(function (series) {
        return !series.completed;
      })[0] || program.series[0];

      // see if any series have completed activities
      vm.started = _.find(vm.program.series, function (s) {
        var completed = _.find(s.activities, function (a) {
          return a.responseStatus !== 'INCOMPLETE';
        });
        return completed;
      });

      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.PAGE_TITLE, {
        pageTitle: program.title
      });

      focus.byId('hero-title');
    }
  }
})();